import React from "react";
import { legendItems } from "../constants/legendItems";

interface SchulferienModalProps {
  data: any[];
  onClose: () => void;
  onEdit: (event: any) => void;
}

function formatDateDMY(dateString: string) {
  const d = new Date(dateString);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
}

const SchulferienModal: React.FC<SchulferienModalProps> = ({ data, onClose, onEdit }) => {
  const ferienLegend = legendItems.find(item => item.label === "Schulferien");
  const ferienColor = ferienLegend ? ferienLegend.color : "#3498db";
  const ferienTextColor = "#fff";
  const ferienHeaderBg = ferienColor + "22";
  const ferienHeaderBorder = ferienColor + "55";

  // Gruppiere alle Schulferien-Termine nach Name und Zeitraum
  const ferienEvents = data.filter(ev => ev.bgColor === ferienColor);
  const gruppiert: { [key: string]: { name: string, start: string, end: string, event: any } } = {};
  ferienEvents.forEach(ev => {
    if (!gruppiert[ev.title]) {
      gruppiert[ev.title] = {
        name: ev.title,
        start: ev.startTime,
        end: ev.endTime,
        event: ev
      };
    } else {
      if (ev.startTime < gruppiert[ev.title].start) gruppiert[ev.title].start = ev.startTime;
      if (ev.endTime > gruppiert[ev.title].end) gruppiert[ev.title].end = ev.endTime;
    }
  });
  const gruppiertArr = Object.values(gruppiert).sort((a, b) => a.start.localeCompare(b.start));

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.5)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff",
          padding: 32,
          borderRadius: 16,
          minWidth: 320,
          maxWidth: 600,
          width: "90vw",
          maxHeight: "80vh",
          boxShadow: "0 8px 32px rgba(44,62,80,0.18)",
          overflowY: "auto"
        }}
        onClick={e => e.stopPropagation()}
      >
        <h2 style={{marginTop:0,marginBottom:24,fontWeight:700,fontSize: "1.5rem",color: ferienColor,letterSpacing:1}}>Schulferien</h2>
        <div style={{overflowX:'auto'}}>
          <table style={{
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: 0,
            background: "#faf9f6",
            borderRadius: 12,
            overflow: "hidden",
            boxShadow: "0 2px 8px rgba(44,62,80,0.08)"
          }}>
            <thead>
              <tr style={{background: ferienHeaderBg}}>
                <th style={{padding: "12px 8px", textAlign: "left", fontWeight: 600, fontSize: 15, color: ferienColor, borderBottom: `2px solid ${ferienHeaderBorder}`}}>Titel</th>
                <th style={{padding: "12px 8px", textAlign: "center", fontWeight: 600, fontSize: 15, color: ferienColor, borderBottom: `2px solid ${ferienHeaderBorder}`}}>Start</th>
                <th style={{padding: "12px 8px", textAlign: "center", fontWeight: 600, fontSize: 15, color: ferienColor, borderBottom: `2px solid ${ferienHeaderBorder}`}}>Ende</th>
              </tr>
            </thead>
            <tbody>
              {ferienEvents.length === 0 ? (
                <tr><td colSpan={3} style={{ padding: 16, textAlign: "left", color: "#888" }}>Keine Schulferien-Termine vorhanden.</td></tr>
              ) : (
                gruppiertArr.map((g, i) => (
                  <tr
                    key={g.name + g.start + g.end}
                    style={{
                      background: i%2===0?"#fff":"#f0f7ff",
                      transition: "background 0.2s",
                      cursor: "pointer"
                    }}
                    title="Diesen Zeitraum bearbeiten"
                    onClick={() => {
                      onClose();
                      setTimeout(() => onEdit(g.event), 200);
                    }}
                    onMouseOver={e => (e.currentTarget.style.background = ferienHeaderBg)}
                    onMouseOut={e => (e.currentTarget.style.background = i%2===0?"#fff":"#f0f7ff")}
                  >
                    <td style={{ padding: "10px 8px", fontWeight: 500, textAlign: "left" }}>{g.name}</td>
                    <td style={{ padding: "10px 8px", textAlign: "center" }}>{formatDateDMY(g.start)}</td>
                    <td style={{ padding: "10px 8px", textAlign: "center" }}>{formatDateDMY(g.end)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <button
          style={{
            marginTop: 24,
            background: ferienColor,
            color: ferienTextColor,
            border: "none",
            borderRadius: 8,
            padding: "10px 28px",
            fontWeight: 600,
            fontSize: 16,
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(44,62,80,0.08)",
            transition: "background 0.2s"
          }}
          onClick={onClose}
          onMouseOver={e => (e.currentTarget.style.background = ferienLegend ? ferienLegend.color : '#217dbb')}
          onMouseOut={e => (e.currentTarget.style.background = ferienColor)}
        >Schließen</button>
      </div>
    </div>
  );
};

export default SchulferienModal;
